// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vavk","type":"styles_type__kBCFa","choices":"styles_choices__1zeeh"};